var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66262 16.313C12.4534 16.313 16.1687 10.6856 16.1687 5.80694C16.1687 5.64874 16.1652 5.48702 16.1582 5.32882C16.8809 4.80615 17.5046 4.15874 18 3.41702C17.3269 3.7165 16.6122 3.91209 15.8804 3.9971C16.651 3.53523 17.2279 2.80965 17.5043 1.95487C16.7794 2.38447 15.9867 2.68751 15.1601 2.85101C14.6031 2.25922 13.8667 1.86739 13.0648 1.73609C12.2628 1.60479 11.4399 1.74134 10.7233 2.12462C10.0067 2.50791 9.43635 3.11658 9.10039 3.85653C8.76442 4.59649 8.68157 5.42651 8.86465 6.21827C7.39687 6.14462 5.96095 5.76333 4.64999 5.09912C3.33902 4.43492 2.18227 3.50263 1.25473 2.36269C0.7833 3.17548 0.639042 4.13728 0.851273 5.05262C1.0635 5.96795 1.6163 6.76814 2.3973 7.29054C1.81097 7.27192 1.23748 7.11406 0.724219 6.82999V6.87569C0.723693 7.72866 1.01857 8.55549 1.55873 9.21563C2.09889 9.87576 2.85099 10.3285 3.68719 10.4968C3.14404 10.6454 2.57399 10.667 2.02113 10.5601C2.25709 11.2936 2.71618 11.9352 3.33433 12.3953C3.95248 12.8554 4.69884 13.111 5.46926 13.1265C4.16132 14.1539 2.54563 14.7111 0.882422 14.7085C0.587465 14.7081 0.292799 14.69 0 14.6544C1.68964 15.7384 3.65515 16.3141 5.66262 16.313Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.74c32ec057a82a6d178514eb1a37fed0.svg";
export { ForwardRef as ReactComponent };